export interface AppConfig {
    requestsType: RequestsType;
}

export enum RequestsType {
    Http,
    SignalR,
}
